module.exports = __webpack_public_path__ + "img/tx-green120.b1876866.gif";